// extracted by mini-css-extract-plugin
module.exports = {"article":"article-module--article--tIlev","content":"article-module--content--2GvBw","inner":"article-module--inner--3goRK"};